import Guard from 'arg-guard'

/**
 * Defined structure of a navigation link.
 * @export NavigationLink
 * @class NavigationLink
 */
export default class NavigationLink {

    /**
     * Creates an instance of NavigationLink.
     * @param {string} text
     * @param {string|Vue} to The url or route name (if an appLink) or modal component name (if modalLink).
     * @param {number} order=0 The order of the link on the page / list
     * @param {boolean} appLink=false Is the link internal to the app?
     * @param {boolean} modalLink=false Is the link a modal?
     * @memberof NavigationLink
     */
    constructor(text, to, { order = 0, appLink = false, modalLink = false } = { order: 0, appLink: false, modalLink: false }) {
        Guard.throwIf(text, 'text')
        Guard.throwIf(to, 'to')

        /**
         * @type {string|Vue}
         */
        this.key = to

        /**
         * @type {string}
         */
        this.text = text

        /**
         * @type {string|Vue}
         */
        this.url = modalLink ? '#' : to

        /**
         * @type {number}
         */
        this.order = order

        /**
         * @type {string}
         */
        this.target = appLink || modalLink ? '_self' : '_blank'

        /**
         * @type {boolean}
         */
        this.routed = appLink

        /**
         * @type {string|Vue|null}
         */
        this.modal = modalLink ? to : null

        /**
         * @type {boolean}
         */
        this.passReferral = !this.routed && !this.modal && !this.url.includes('mailto://')
    }
}
